import React, { useEffect, useState, } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

const convert = (result, hiddenNoTag, requiredTag) => {
  const all = [{
    label: '全部',
    value: 1,
    children: result.filter(n => !requiredTag?.includes(n.tagId)
     && (hiddenNoTag ? n.tagId !== -1 : n.tagId)).map(m => ({ label: m.tagName, value: m.tagId }))
  }]
  all.unshift({ label: '已选定', value: null, children: [] })
  return all
}

export default (props) => {
  const { inspirationId, onChange, value, hiddenNoTag, requiredTag = [], params, hiddenAnyMatchFlag, placeholder, ...otherProps } = props
  const [options, setOptions] = useState([])
  const [anyMatchFlag, setAnyMatchFlag] = useState(params?.anyMatchFlag || 1)
  const [tagIdList, setTagIdList] = useState(value || [])
  useEffect(() => {
    fetchTags()
  }, [inspirationId])

  const fetchTags = async () => {
    try {
      const res = await request.spost('/zhikuan/img-tag/selector', { inspirationId }, 'MNTagSearch')
      setOptions(convert(res || [], hiddenNoTag, requiredTag))
    } catch (err) {
      console.error(err)
    }
  }

  const filter = (_value, data, _anyMatchFlag) => {
    if (_anyMatchFlag === 2) {
      if (!_value.length) { return data }
      if (_value.includes(-1)) {
        return data.filter(m => m.value === -1)
      }
      return data.filter(m => m.value !== -1)
    }
    return data
  }
  return <Select.Cascade
    className="meinian-tag-select"
    trigger="click"
    value={value}
    onChange={_tagIdList => onChange && onChange(_tagIdList, anyMatchFlag)}
    onChangeInner={_tagIdList => setTagIdList(_tagIdList)}
    placeholder={placeholder || '标签'}
    data={options}
    dataFilter={(_value, data) => filter(_value, data, anyMatchFlag)}
    defaultLeftValue={1}
    emptyText="暂无相关标签"
    leftSlot={!hiddenAnyMatchFlag ? <Select
      value={anyMatchFlag}
      data={[{ label: '任意符合', value: 1 }, {
        label: '全部符合',
        value: 2,
        disabled: anyMatchFlag === 1 && tagIdList.length > 1 && tagIdList.includes(-1)
      }]}
      onChange={_anyMatchFlag => setAnyMatchFlag(_anyMatchFlag)}
      allowClear={false}
      displayStyle={{ position: 'absolute', left: 26, bottom: 8 }}
    /> : null}
    {...otherProps}
  />
}
